<template>
  <div class="">
    <div class="lg:flex md:flex gap-8 px-10 mb-5">
      <div class="lg:w-5/12 md:w-5/12 mt-28 mob-hidden">
        <Map />
      </div>
      <div class="lg:w-7/12 md:w-7/12 lg:mt-28 md:mt-20 mt-20">
        <Grid :location="location" />
        <Bcard />
        <Pagination />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import Map from "./components/Map.vue";
import Grid from "./components/Grid.vue";
import Bcard from "./components/Bcard.vue";
import Pagination from "./components/Paginationn.vue";

export default {
  props: ["location"],
  components: {
    Map,
    Footer,
    DownloadApp,
    Grid,
    Bcard,
    Pagination,
  },
};
</script>

<style></style>
